import gql from "graphql-tag";

export default gql`
  mutation CreateRelation($idAudio: Int!, $idProject: Int!) {
    createRelation(idAudio: $idAudio, idProject: $idProject)
  }
`;